import { useEffect, useState } from "react";
import styles from "./style.module.scss";
import MobileImage01 from "src/assets/top-images/mobile/01.jpg";
import MobileImage02 from "src/assets/top-images/mobile/02.jpg";
import MobileImage03 from "src/assets/top-images/mobile/03.jpg";
import MobileImage04 from "src/assets/top-images/mobile/04.jpg";
import MobileImage05 from "src/assets/top-images/mobile/05.jpg";
import MobileImage06 from "src/assets/top-images/mobile/06.jpg";
import MobileImage07 from "src/assets/top-images/mobile/07.jpg";
import MobileImage08 from "src/assets/top-images/mobile/08.jpg";
import PcImage01 from "src/assets/top-images/pc/01.jpg";
import PcImage02 from "src/assets/top-images/pc/02.jpg";
import PcImage03 from "src/assets/top-images/pc/03.jpg";
import PcImage04 from "src/assets/top-images/pc/04.jpg";
import PcImage05 from "src/assets/top-images/pc/05.jpg";
import PcImage06 from "src/assets/top-images/pc/06.jpg";
import PcImage07 from "src/assets/top-images/pc/07.jpg";
import PcImage08 from "src/assets/top-images/pc/08.jpg";
import Logo from "src/assets/logo.png";
import WebpImage from "src/utils/WebpImage";

const PC_IMAGES = [
  PcImage01,
  PcImage02,
  PcImage03,
  PcImage04,
  PcImage05,
  PcImage06,
  PcImage07,
  PcImage08,
];

const MOBILE_IMAGES = [
  MobileImage01,
  MobileImage02,
  MobileImage03,
  MobileImage04,
  MobileImage05,
  MobileImage06,
  MobileImage07,
  MobileImage08,
];

export const TopSection = () => {
  const [index, setIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const activeImages = isMobile ? MOBILE_IMAGES : PC_IMAGES;

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 960);
    };

    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % activeImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [activeImages]);

  return (
    <section className={styles.container}>
      <div className={styles.backgroundBox}>
        {activeImages.map((img, i) => (
          <WebpImage
            key={i}
            src={img}
            alt={`background ${i + 1}`}
            className={`${styles.backgroundImg} ${
              i === index ? styles.active : ""
            }`}
          />
        ))}
      </div>

      <div className={styles.logoBox}>
        <WebpImage src={Logo} alt="logo" />
        <h1>ISHINOMAKI MARIN VILLAGE</h1>
      </div>
      <div className={styles.box}>
        <div className={styles.titleBox}>
          <h2>
            石巻の海と
            <br />
            海のある
            <br className={styles.br} />
            暮らしに
          </h2>
          <p>Dive!</p>
        </div>
      </div>
    </section>
  );
};
